const defaultBreakpoints = {
    xs: 420,
    small: 640,
    medium: 768,
    large: 1024,
    xl: 1280,
    xxl: 1536,
};

const breakpointMap = {
    xs: 0,
    sm: 1,
    small: 1,
    md: 2,
    medium: 2,
    lg: 3,
    large: 3,
    xl: 4,
    xxl: 5,
    inf: 6,
};

class Breakpoint {
    constructor(bp = null) {
        this.currentBreakpoint = bp;
    }
    eq(val) {
        return this.currentBreakpoint === breakpointMap[val];
    }
    lt(val) {
        return this.currentBreakpoint < breakpointMap[val];
    }
    lte(val) {
        return this.currentBreakpoint <= breakpointMap[val];
    }
    gt(val) {
        return this.currentBreakpoint > breakpointMap[val];
    }
    gte(val) {
        return this.currentBreakpoint >= breakpointMap[val];
    }
    ne(val) {
        return this.currentBreakpoint !== breakpointMap[val];
    }
}

export default {
    data() {
        return {
            currentBreakpoint: new Breakpoint(),
        };
    },
    mounted() {
        window.addEventListener('resize', this.handleWindowResize);
        this.handleWindowResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
    computed: {
        _breakpoints() {
            return {
                ...defaultBreakpoints,
                xs: defaultBreakpoints.xs,
                sm: defaultBreakpoints.small,
                md: defaultBreakpoints.medium,
                lg: defaultBreakpoints.large,
                xl: defaultBreakpoints.xl,
                xxl: defaultBreakpoints.xxl,
            };
        },
    },
    methods: {
        handleWindowResize() {
            const clientWidth = window.innerWidth;
            if (clientWidth < this._breakpoints.xs) {
                this.$set(this.currentBreakpoint, 'currentBreakpoint', breakpointMap.xs);
            } else if (clientWidth < this._breakpoints.sm) {
                this.$set(this.currentBreakpoint, 'currentBreakpoint', breakpointMap.sm);
            } else if (clientWidth < this._breakpoints.md) {
                this.$set(this.currentBreakpoint, 'currentBreakpoint', breakpointMap.md);
            } else if (clientWidth < this._breakpoints.lg) {
                this.$set(this.currentBreakpoint, 'currentBreakpoint', breakpointMap.lg);
            } else if (clientWidth < this._breakpoints.xl) {
                this.$set(this.currentBreakpoint, 'currentBreakpoint', breakpointMap.xl);
            } else if (clientWidth < this._breakpoints.xxl) {
                this.$set(this.currentBreakpoint, 'currentBreakpoint', breakpointMap.xxl);
            } else {
                this.$set(this.currentBreakpoint, 'currentBreakpoint', breakpointMap.inf);
            }
        },
    },
};
